import requests from '@/utils/request.js'
import { callDynamicAPI } from '@/utils/dynamicApi.js'

// 使用动态API配置替代硬编码URL
export const getUserInfoAPI = (data) => callDynamicAPI('user', 'login', data)
export const getUserInfo = (data) => callDynamicAPI('user', 'userInfo', data)



